import thunk from 'redux-thunk';
import { applyMiddleware, compose, createStore } from 'redux';
import { routerMiddleware } from 'connected-react-router';

import rootReducer from './reducers/index';

export default function configureStore(initialState, history) {
    const finalCreateStore = compose(
        applyMiddleware(thunk),
        __CLIENT__ ? applyMiddleware(routerMiddleware(history)) : (f) => f,
        // eslint-disable-next-line no-undef
        typeof window === 'object' && typeof window.devToolsExtension !== 'undefined'
            ? // eslint-disable-next-line no-undef
              window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
            : (f) => f
    )(createStore);

    return finalCreateStore(rootReducer(history), initialState);
}
